module.exports = __webpack_public_path__ + "img/areal.58a530d5.png";